/**
 * ScalpIt Product Page JS
 * File: assets/scalpit-product.js
 */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- Gallery thumbnails ---- */
  const thumbs = document.querySelectorAll('.sc-product-gallery__thumb');
  const mainImg = document.querySelector('.sc-product-gallery__main img');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
      if (mainImg && this.dataset.src) {
        mainImg.src = this.dataset.src;
        mainImg.srcset = '';
      }
    });
  });

  /* ---- Color swatches ---- */
  const swatches = document.querySelectorAll('.sc-swatch');
  const swatchName = document.querySelector('.sc-swatch-name');

  swatches.forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      swatches.forEach(function (s) { s.classList.remove('is-active'); });
      this.classList.add('is-active');
      if (swatchName) swatchName.textContent = this.dataset.label || '';
      updateVariant();
    });
  });

  /* ---- Size buttons ---- */
  const sizeBtns = document.querySelectorAll('.sc-size-btn');

  sizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      sizeBtns.forEach(function (b) { b.classList.remove('is-active'); });
      this.classList.add('is-active');
      updateVariant();
    });
  });

  /* ---- Variant update (aggiorna id variante nel form ATC) ---- */
  function updateVariant() {
    var selectedColor = document.querySelector('.sc-swatch.is-active');
    var selectedSize  = document.querySelector('.sc-size-btn.is-active');
    var colorVal = selectedColor ? selectedColor.dataset.value : '';
    var sizeVal  = selectedSize  ? selectedSize.dataset.value  : '';

    // Cerca la variante corrispondente nei dati prodotto
    var productData = window.ScalpItProduct;
    if (!productData) return;

    var matched = productData.variants.find(function (v) {
      var matchColor = !colorVal || v.option1 === colorVal || v.option2 === colorVal || v.option3 === colorVal;
      var matchSize  = !sizeVal  || v.option1 === sizeVal  || v.option2 === sizeVal  || v.option3 === sizeVal;
      return matchColor && matchSize;
    });

    if (matched) {
      // Aggiorna input hidden nel form ATC
      var variantInputs = document.querySelectorAll('[name="id"]');
      variantInputs.forEach(function (input) { input.value = matched.id; });

      // Aggiorna prezzo
      var priceEl = document.querySelector('.sc-product-info__price');
      var compareEl = document.querySelector('.sc-product-info__compare');
      if (priceEl) priceEl.textContent = formatMoney(matched.price);
      if (compareEl && matched.compare_at_price > matched.price) {
        compareEl.textContent = formatMoney(matched.compare_at_price);
        compareEl.style.display = '';
      } else if (compareEl) {
        compareEl.style.display = 'none';
      }

      // Aggiorna stato disponibilità
      var atcBtn = document.querySelector('.sc-product-cta-primary');
      if (atcBtn) {
        atcBtn.disabled = !matched.available;
        atcBtn.textContent = matched.available ? 'Aggiungi al carrello' : 'Esaurito';
      }

      // Sticky bar
      var stickyPrice = document.querySelector('.sc-sticky-bar__price');
      if (stickyPrice) stickyPrice.textContent = formatMoney(matched.price);
    }
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  /* ---- Quantità ---- */
  var qtyNum = document.querySelector('.sc-qty__num');
  var qtyMinus = document.querySelector('.sc-qty__btn--minus');
  var qtyPlus  = document.querySelector('.sc-qty__btn--plus');

  if (qtyMinus && qtyPlus && qtyNum) {
    qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyNum.textContent, 10);
      if (v > 1) {
        qtyNum.textContent = v - 1;
        updateQtyInput(v - 1);
      }
    });
    qtyPlus.addEventListener('click', function () {
      var v = parseInt(qtyNum.textContent, 10);
      qtyNum.textContent = v + 1;
      updateQtyInput(v + 1);
    });
  }

  function updateQtyInput(val) {
    var qtyInputs = document.querySelectorAll('[name="quantity"]');
    qtyInputs.forEach(function (i) { i.value = val; });
    var stickyBtn = document.querySelector('.sc-sticky-bar__btn');
    if (stickyBtn) stickyBtn.dataset.qty = val;
  }

  /* ---- Tab prodotto ---- */
  var tabBtns    = document.querySelectorAll('.sc-tab-btn');
  var tabPanels  = document.querySelectorAll('.sc-tab-content');

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = this.dataset.tab;
      tabBtns.forEach(function (b)   { b.classList.remove('is-active'); });
      tabPanels.forEach(function (p) { p.classList.remove('is-active'); });
      this.classList.add('is-active');
      var panel = document.getElementById('tab-' + target);
      if (panel) panel.classList.add('is-active');
    });
  });

  /* ---- Sticky bar mobile ---- */
  var stickyBar = document.querySelector('.sc-sticky-bar');
  var productInfo = document.querySelector('.sc-product-info');

  if (stickyBar && productInfo) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            stickyBar.classList.add('is-visible');
          } else {
            stickyBar.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(productInfo);
  }

  /* ---- ATC da sticky bar ---- */
  var stickyAtcBtn = document.querySelector('.sc-sticky-bar__btn');
  if (stickyAtcBtn) {
    stickyAtcBtn.addEventListener('click', function () {
      var mainAtcBtn = document.querySelector('.sc-product-cta-primary');
      if (mainAtcBtn) mainAtcBtn.click();
    });
  }

  /* ---- Cart: rimozione articolo (AJAX) ---- */
  document.querySelectorAll('.sc-cart-item__remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = this.dataset.key;
      if (!key) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
      .then(function () { location.reload(); })
      .catch(function (err) { console.error('Cart error:', err); });
    });
  });

  /* ---- Cart: aggiorna quantità (AJAX) ---- */
  document.querySelectorAll('.sc-cart__qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key  = this.dataset.key;
      var step = parseInt(this.dataset.step, 10);
      var numEl = this.closest('.sc-cart__qty-wrap').querySelector('.sc-qty__num');
      if (!numEl) return;
      var current = parseInt(numEl.textContent, 10);
      var newQty  = Math.max(0, current + step);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
      .then(function () { location.reload(); })
      .catch(function (err) { console.error('Cart error:', err); });
    });
  });

  /* ---- Mobile nav hamburger ---- */
  var hamburger  = document.querySelector('.sc-nav__hamburger');
  var mobileMenu = document.querySelector('.sc-nav__mobile-menu');
  var closeBtn   = document.querySelector('.sc-nav__mobile-close');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      mobileMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (closeBtn && mobileMenu) {
    closeBtn.addEventListener('click', function () {
      mobileMenu.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

});